import colormap from 'colormap';

const apcpcolors = [
    [127, 255, 0], [0, 205, 0], [0, 139, 0], [16, 78, 139],
    [30, 144, 255], [0, 178, 238], [0, 238, 238], [137, 104, 205],
    [145, 44, 238], [139, 0, 139]
];
const apcptotalcolors = [
    [127, 255, 0], [0, 205, 0], [0, 139, 0], [16, 78, 139],
    [30, 144, 255], [0, 178, 238], [0, 238, 238], [137, 104, 205],
    [145, 44, 238], [139, 0, 139], [139, 0, 0], [205, 0, 0],
    [238, 64, 0], [255, 127, 0], [205, 133, 0], [255, 215, 0],
    [255, 255, 0], [255, 174, 185]
];

export const drawColorbar = (variable, colormapName, reverse, minValue, maxValue, levels, bounded, cmapSpacing, setCmapSpacing) => {
    const canvas = document.getElementById('colorbar');
    const ctx = canvas.getContext('2d');
    const ypos = [];

    let colors;

    if (variable === 'apcp') {
        colors = apcpcolors.map(color => `rgba(${color[0]}, ${color[1]}, ${color[2]}, 1)`);
    } else if (variable === 'apcptotal') {
        colors = apcptotalcolors.map(color => `rgba(${color[0]}, ${color[1]}, ${color[2]}, 1)`);
    } else {
        colors = colormap({
            colormap: colormapName,
            nshades: levels,
            format: 'rgba',
            alpha: 1,
        });
    }

    if (reverse) {
        colors = colors.reverse();
    }

    canvas.width = 40;
    canvas.height = 440;

    const blockHeight = canvas.height / levels;

    for (let i = 0; i < levels; i++) {
        const color = colors[i];
        const y = blockHeight * i;
        ypos.push(y);

        if (typeof color === 'string') {
            ctx.fillStyle = color;
        } else {
            ctx.fillStyle = `rgba(${color[0]}, ${color[1]}, ${color[2]}, ${color[3]})`;
        }

        ctx.fillRect(0, y, canvas.width, blockHeight + 1);
    }
    ypos.push(blockHeight * levels);
    setCmapSpacing(ypos);
};

export const drawTicksAndLabels = (selectedVariable, reverse, minValue, maxValue, levels, ticks, decimals, units, bounded, cmapSpacing) => {
    const container = document.getElementById('color-tick-container');
    container.innerHTML = '';

    let starti, endi, tickValues, tickValuesKeep;

    if (bounded === "neither") {
        starti = 1;
        endi = cmapSpacing.length - 1;

        const step = (maxValue - minValue) / (levels - 2);
        const max = maxValue + step;
        tickValues = [];
        for (let i = 0; i < levels + 1; i++) {
            if (reverse) {
                tickValues.push(parseFloat((max - (i * step)).toFixed(2)));
            } else {
                tickValues.push(parseFloat((minValue - (i * step)).toFixed(2)));
            }
        }

        const stepKeep = (maxValue - minValue) / (ticks - 3);
        tickValuesKeep = [];
        for (let i = 0; i < ticks - 2; i++) {
            if (reverse) {
                tickValuesKeep.push(parseFloat((maxValue - (i * stepKeep)).toFixed(2)));
            } else {
                tickValuesKeep.push(parseFloat((minValue - (i * stepKeep)).toFixed(2)));
            }
        }
    } else if (bounded === "both") {
        starti = 0;
        endi = cmapSpacing.length;
    } else if (bounded === "lower") {
        starti = 1;
        endi = cmapSpacing.length;

        const step = (maxValue - minValue) / (levels - 1);
        const max = maxValue + step;
        tickValues = [];
        for (let i = 0; i < levels + 1; i++) {
            if (reverse) {
                tickValues.push(parseFloat((max - (i * step)).toFixed(2)));
            } else {
                tickValues.push(parseFloat((minValue - (i * step)).toFixed(2)));
            }
        }

        const stepKeep = (maxValue - minValue) / (ticks - 3);
        tickValuesKeep = [];
        for (let i = 0; i < ticks - 2; i++) {
            if (reverse) {
                tickValuesKeep.push(parseFloat((maxValue - (i * stepKeep)).toFixed(2)));
            } else {
                tickValuesKeep.push(parseFloat((minValue - (i * stepKeep)).toFixed(2)));
            }
        }
    } else if (bounded === "upper") {
        starti = 0;
        endi = cmapSpacing.length - 1;
    } else if (bounded === "apcp") {
        tickValues = [0.01, 0.10, 0.25, 0.50, 0.75, 1, 1.25, 1.50, 1.75, 2.00, 2.50].reverse();
        tickValuesKeep = [0.01, 0.10, 0.25, 0.50, 0.75, 1, 1.25, 1.50, 1.75, 2.00, 2.50].reverse();
        starti = 1;
        endi = cmapSpacing.length;
    } else if (bounded === "apcptotal") {
        tickValues = [0.01, 0.10, 0.25, 0.50, 0.75, 1, 1.25, 1.50, 1.75, 2.00, 2.50, 3, 4, 5, 7, 10, 15, 20, 25].reverse();
        tickValuesKeep = [0.01, 0.10, 0.25, 0.50, 0.75, 1, 1.25, 1.50, 1.75, 2.00, 2.50, 3, 4, 5, 7, 10, 15, 20, 25].reverse();
        starti = 1;
        endi = cmapSpacing.length;
    }

    for (let i = starti; i < endi; i++) {
        const value = tickValues[i];
        if (tickValuesKeep.includes(value)) {
            const tickDiv = document.createElement('div');
            tickDiv.className = 'color-tick';

            const labelDiv = document.createElement('div');
            labelDiv.className = 'color-label';
            labelDiv.innerText = value.toFixed(decimals) + ` ${units}`;

            const tickContainer = document.createElement('div');
            tickContainer.className = 'color-tick-container';
            tickContainer.style.top = `${cmapSpacing[i]}px`;

            tickContainer.appendChild(tickDiv);
            tickContainer.appendChild(labelDiv);
            container.appendChild(tickContainer);
        }
    }
};

// --- colorMapping: config for each variable's colorbar ---

const PRESSURE_LEVELS = [1000, 925, 850, 700, 500, 300, 250, 200];

function generateEntries(prefix, ranges, base) {
    return Object.fromEntries(
        Object.entries(ranges).map(([lev, [min, max]]) => [
            `${prefix}${lev}`,
            { ...base, minValue: min, maxValue: max }
        ])
    );
}

function generateUniform(prefix, base) {
    return Object.fromEntries(
        PRESSURE_LEVELS.map(lev => [`${prefix}${lev}`, { ...base }])
    );
}

const heightsBase = { colorMap: "viridis", reverse: true, levels: 22, ticks: 13, decimals: 0, units: "m", bounded: "neither" };
const heightsRanges = {
    1000: [-400, 400], 925: [200, 1000], 850: [900, 1700], 700: [2300, 3300],
    500: [4800, 6000], 300: [8000, 10000], 250: [9250, 11250], 200: [10500, 13500]
};

const tempBase = { colorMap: "viridis", reverse: true, levels: 22, ticks: 13, decimals: 0, units: "\u00B0C", bounded: "neither" };
const tempRanges = {
    1000: [-40, 40], 925: [-40, 40], 850: [-30, 30], 700: [-40, 20],
    500: [-50, 0], 300: [-70, -20], 250: [-70, -30], 200: [-70, -40]
};

const windBase = { colorMap: "viridis", reverse: true, levels: 21, ticks: 13, decimals: 1, units: "m/s", bounded: "lower" };
const windRanges = {
    10: [0, 30], 1000: [0, 30], 925: [0, 30], 850: [0, 30],
    700: [0, 40], 500: [0, 50], 300: [0, 70], 250: [0, 70], 200: [0, 70]
};

const rhBase = { colorMap: "viridis", reverse: true, levels: 21, ticks: 13, decimals: 0, units: "%", bounded: "lower", minValue: 0, maxValue: 100 };

const vvelBase = { colorMap: "RdBu", reverse: true, levels: 22, ticks: 13, decimals: 1, units: "m/s", bounded: "neither", minValue: -1, maxValue: 1 };

export const colorMapping = {
    // Heights
    ...generateEntries("z", heightsRanges, heightsBase),

    // Pressure
    msl: { minValue: 950, maxValue: 1050, colorMap: "viridis", reverse: true, levels: 102, ticks: 13, decimals: 0, units: "hPa", bounded: "neither" },

    // Temperature
    t2: { minValue: -50, maxValue: 50, colorMap: "viridis", reverse: true, levels: 102, ticks: 13, decimals: 0, units: "\u00B0C", bounded: "neither" },
    ...generateEntries("t", tempRanges, tempBase),

    // Winds
    windmag10: { ...windBase, minValue: 0, maxValue: 30 },
    ...generateEntries("windmag", windRanges, windBase),

    // Relative Humidity
    ...generateUniform("r", rhBase),

    // Vertical Velocity
    ...generateUniform("w", vvelBase),

    // Precipitation
    apcp: { minValue: 0, maxValue: 2, colorMap: "viridis", reverse: true, levels: 10, ticks: 11, decimals: 2, units: "in.", bounded: "apcp" },
    apcptotal: { minValue: 0, maxValue: 20, colorMap: "viridis", reverse: true, levels: 18, ticks: 19, decimals: 2, units: "in.", bounded: "apcptotal" },
};
